import React, { useEffect, useMemo } from 'react';
import { MapContainer, Marker, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import LeafletTileLayer from './LeafletTileLayer';

const DEFAULT_CENTER = { latitude: -3.4324, longitude: 119.3430 };
const DEFAULT_ZOOM = 16;

const hasValidCoordinates = (lat, lon) => {
  const latitude = Number(lat);
  const longitude = Number(lon);
  return Number.isFinite(latitude) && Number.isFinite(longitude) && latitude >= -90 && latitude <= 90 && longitude >= -180 && longitude <= 180;
};

const PIN_ICON = L.divIcon({
  className: 'leaflet-pin-icon-wrapper',
  html: '<div style="width:14px;height:14px;border-radius:999px;background:#ef4444;border:2px solid #fff;box-shadow:0 0 0 2px rgba(239,68,68,.3);"></div>',
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});

const RecenterController = ({ center }) => {
  const map = useMap();

  useEffect(() => {
    if (!Array.isArray(center) || center.length !== 2) return;
    map.setView(center, map.getZoom(), { animate: false });
  }, [center, map]);

  return null;
};

const ClickHandler = ({ onChange }) => {
  useMapEvents({
    click(event) {
      if (!onChange) return;
      onChange(event.latlng.lat, event.latlng.lng);
    },
  });

  return null;
};

const LeafletPinPicker = ({ title, latitude, longitude, onChange, heightClass = 'h-56', fallbackCenter = DEFAULT_CENTER }) => {
  const markerPosition = useMemo(() => {
    if (hasValidCoordinates(latitude, longitude)) {
      return [Number(latitude), Number(longitude)];
    }
    if (hasValidCoordinates(fallbackCenter?.latitude, fallbackCenter?.longitude)) {
      return [Number(fallbackCenter.latitude), Number(fallbackCenter.longitude)];
    }
    return [DEFAULT_CENTER.latitude, DEFAULT_CENTER.longitude];
  }, [latitude, longitude, fallbackCenter]);

  return (
    <div className="space-y-2">
      <p className="text-xs text-gray-400">{title}</p>
      <div className={`relative w-full overflow-hidden rounded-lg border border-white/10 ${heightClass}`}>
        <MapContainer
          center={markerPosition}
          zoom={DEFAULT_ZOOM}
          className="h-full w-full"
          scrollWheelZoom
        >
          <LeafletTileLayer />

          <RecenterController center={markerPosition} />
          <ClickHandler onChange={onChange} />
          <Marker
            position={markerPosition}
            icon={PIN_ICON}
            draggable
            eventHandlers={{
              dragend: (event) => {
                const position = event.target.getLatLng();
                if (onChange) onChange(position.lat, position.lng);
              },
            }}
          />
        </MapContainer>
      </div>
      <p className="text-xs text-gray-500">Klik peta atau geser pin untuk memindahkan lokasi.</p>
    </div>
  );
};

export default LeafletPinPicker;

